import { useMutation, useQueryClient } from 'react-query';
import { apis } from 'apis/apis';
import useCommonStore from 'store/useCommonStore';
import type { IFilter } from 'apis/match_apis';
import type { PlatformCode } from 'type/common';

// 필터 업데이트
export const useSetFilterMutation = <T>(platform_code?: PlatformCode, option?: T) => {
	const { platform } = useCommonStore();
	const queryClient = useQueryClient();
	return useMutation(
		(data: IFilter) => apis.setFilter(platform_code ?? platform.code ?? 'ig', data),
		{
			onSuccess: () => {
				return queryClient.invalidateQueries('match_filter');
			},
			onError: (err) => {
				console.log(err);
			},
			...option,
		},
	);
};
